import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from '../../../components/Button';
import api from '../../../services/api';
import { useAlert } from '../../../hooks/useAlert';
import { useForm } from '../../../hooks/useForm';

import ImageSelectVerificationEnterCode from '../../../assets/verify-account-enter-code.svg';

import { VerifyAccountContainer, EnterVerificationCode } from './styles';

interface EnterCodeFormEntries {
  code: string;
}

function VerifyAccount() {
  const history = useHistory();
  const { Alerts, handleAlert } = useAlert();
  const { getEntriesByEvent } = useForm();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    const entries = getEntriesByEvent<EnterCodeFormEntries>(e);
    if (!entries) return;

    const { code } = entries;

    const response = await api(`account-confirmation?code=${code}`)
      .then(response => response && response)
      .catch(err => console.log(err))
    ;

    if (!response) return handleAlert(400, 'Error', 'Ops, não foi possível verificar esse código, tente novamente mais tarde.');
    if (response.status === 400) return handleAlert(400, 'Error', 'Ops, código inválido, verifique o código e tente novamente.');

    handleAlert(200, 'Sucesso', 'Oba, sua conta foi verificada! Faça login e aproveite!');
    setTimeout(() => {
      history.push('/login')
    }, 1000);
  }

  return (
    <VerifyAccountContainer>
      <EnterVerificationCode>
        <img 
          src={ImageSelectVerificationEnterCode} 
          alt="Digite o código de verificação" 
        />

        <div className="heading">
          <h1>Digite o código</h1>
  
          <p>
            Pronto, agora você só precisa digitar o código de verificação para já começar a usar sua conta.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <input type="text" name="code" required />

          <Button type="submit">
            Continuar
          </Button>
        </form>
      </EnterVerificationCode>

      <Alerts />
    </VerifyAccountContainer>
  );
};

export default VerifyAccount;
